"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonNouns_en_us = void 0;
function commonNouns_en_us() {
    return {
        "nouns.images": "Images",
        "nouns.name": "Name",
        "nouns.description": "Description",
        "nouns.creationdate": "Creation Date",
        "nouns.qrcode": "QR Code",
        "nouns.actions": "Actions",
        "nouns.preview": "Preview",
        "nouns.details": "Details",
        "nouns.value": "Value",
        "nouns.error": "Error",
        "nouns.icon": "Icon",
        "nouns.help": "Help",
        "nouns.company": "Company",
        "nouns.companyphone": "Company Phone"
    };
}
exports.commonNouns_en_us = commonNouns_en_us;
